import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSecurityCameraProps } from './IconSecurityCamera.types'
import * as Styled from './styles/IconSecurityCamera.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSecurityCamera: FC<IconSecurityCameraProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSecurityCameraProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSecurityCameraProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m19.45 12.016 1.05.714-1.777 2.239a1.25 1.25 0 0 1-1.723.328l-.488-.356m-12.969-.457v6m7.5-7.5-3 4.5h-4.5'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='m14 15.223-8.047-5.2c-1.02-.582-1.383-1.851-.816-2.832l1.539-2.668c.562-.976 1.84-1.296 2.851-.714l10.625 6.836-3.554 4.21a2.1 2.1 0 0 1-2.598.368Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSecurityCamera
